import { StyledIcon } from 'fitify-ui/src/Icon/Icon.Styled'
import { useTheme } from 'styled-components'

export const DoubleArrowIcon = () => {
  const theme = useTheme()

  return (
    <StyledIcon width="100" height="100" viewBox="0 0 100 100" fill="none">
      <g clipPath="url(#clip0_6084_36495)">
        <mask
          id="mask0_6084_36495"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="-1"
          y="-11"
          width="163"
          height="129"
        >
          <rect
            x="-0.351562"
            y="-10.9375"
            width="162.312"
            height="128.725"
            fill="url(#paint0_linear_6084_36495)"
          />
        </mask>
        <g mask="url(#mask0_6084_36495)">
          <g opacity="0.2">
            <g opacity="0.56">
              <path
                d="M59.4887 49.8126C59.4561 47.7095 58.6964 45.9544 56.9999 44.3094L17.4671 5.58287C16.1164 4.26719 14.5272 3.62451 12.5852 3.62451C8.75262 3.62451 5.63281 6.67652 5.63281 10.5278C5.63281 12.4184 6.40868 14.1734 7.80375 15.5709L42.9827 49.7963L7.80375 84.0546C6.42506 85.4356 5.63281 87.1719 5.63281 89.1139C5.63281 92.9488 8.75262 96.0172 12.5852 96.0172C14.4945 96.0172 16.1164 95.3743 17.4671 94.0239L56.9999 55.3161C58.7127 53.6358 59.4887 51.8996 59.4887 49.8126Z"
                fill={theme.colors['N Content/Secondary']}
              />
            </g>
            <path
              d="M93.9926 49.8126C93.96 47.7095 93.2003 45.9544 91.5038 44.3094L51.971 5.58287C50.6203 4.26719 49.0311 3.62451 47.0891 3.62451C43.2565 3.62451 40.1367 6.67652 40.1367 10.5278C40.1367 12.4184 40.9126 14.1734 42.3077 15.5709L77.4866 49.7963L42.3077 84.0546C40.929 85.4356 40.1367 87.1719 40.1367 89.1139C40.1367 92.9488 43.2565 96.0172 47.0891 96.0172C48.9984 96.0172 50.6203 95.3743 51.971 94.0239L91.5038 55.3161C93.2166 53.6358 93.9926 51.8996 93.9926 49.8126Z"
              fill={theme.colors['N Content/Secondary']}
            />
          </g>
        </g>
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_6084_36495"
          x1="80.8046"
          y1="-10.9375"
          x2="80.8046"
          y2="117.787"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopOpacity="0" />
          <stop offset="0.5" stopOpacity="1" />
          <stop offset="1" stopOpacity="0" />
        </linearGradient>
        <clipPath id="clip0_6084_36495">
          <rect width="100" height="100" fill="white" />
        </clipPath>
      </defs>
    </StyledIcon>
  )
}
